if (!('structuredClone' in globalThis)) {
	// @ts-expect-error we do not need types for polyfill;
	import('@ungap/structured-clone').then(({ default: structuredClone }) => {
		globalThis.structuredClone = structuredClone;
	});
}
